import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { createStatistic } from 'store/app/actions';


export interface MemberRequestResponse {
  RmiBirth: string,
  RmiCompanyId: string,
  RmiCreatedDate: string,
  RmiFirstName: string,
  RmiLastName: string
}

export interface EligibilityMemberInfo {
  rafScore: string,
  optCode: string,
  hpCode: string,
  providerKeyId: string,
  companyId: string
  memberId: string,
  memberKeyId: string,
  memberName: string,
  memberFirstName: string,
  memberLastName: string,
  MembMpiNo: string,
  birthDate: string,
  gender: string,
  address: string,
  city: string,
  state: string,
  zipCode: string,
  phone: string,
  healthPlan: string,
  option: string,
  copay: string,
  benefitStartDate: string,
  benefitEndDate: string,
  medicareFlag: string,
  expectedMeasure: boolean,
  hideMeasures: boolean,
  newPatient: string,
  diabetes: string,
  hypertension: string,
  osteoporosis: string,
  arthritis: string,
  smoker: string,
  pregnant: string,
  portalLanguage: string
}

export interface SearchCriteria {
  MemberId?: string
  Provider: string,
  FirstName?: string,
  LastName?: string,
  DateOfBirth?: string | null,
  UserId: string
}

export interface CaseManagementModel {
  CompanyId: null | string,
  DueDate: null | string,
  MembMpiNo: null | string,
  PageIndex: number,
  PageSize: number,
  ReviewDate: null | string,
  TaskOwner: null | string,
  UserId: string
}

export interface GetCmWorkListResponse {
  RmiBirth: string;
  RmiCompanyId: string;
  RmiCompletedDate: string | null;
  RmiCreatedBy: string;
  RmiCreatedDate: string;
  RmiDueDate: string;
  RmiMembId: string;
  RmiMembMpiNo: string;
  RmiModifiedBy: string;
  RmiModifiedDate: string;
  RmiNextReviewDate: string;
  RmiRevFullName: string;
  RmiTaskAcuity: string;
  RmiTaskAcuityId: number;
  RmiTaskDescription: string;
  RmiTaskOwner: string;
  RmiTaskStatus: string;
  RmiTaskStatusId: number;
  RmiUid: number;
}

export const enquireBulkDiags = (searchCriteria: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.ENQUIRE_BULK_DIAGS_REQUEST });

  return api.eligibility.enquireBulkDiags(searchCriteria)
    .then((res: any) => {

      dispatch({
        type: types.ENQUIRE_BULK_DIAGS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.ENQUIRE_BULK_DIAGS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const enquireBulkCpts = (searchCriteria: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.ENQUIRE_BULK_CPTS_REQUEST });

  return api.eligibility.enquireBulkCpts(searchCriteria)
    .then((res: any) => {

      dispatch({
        type: types.ENQUIRE_BULK_CPTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.ENQUIRE_BULK_CPTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const search = (searchCriteria: SearchCriteria) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.SEARCH_MEMBERS_REQUEST });

  return api.eligibility.search(searchCriteria)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_MEMBERS_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'SEARCH MEMBER', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_MEMBERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCMWorkList = (searchModel: CaseManagementModel) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CM_WORK_LIST_REQUEST });

  return api.eligibility.getCMWorkList(searchModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_CM_WORK_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CM_WORK_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMember = (val: any, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_REQUEST });

  return api.eligibility.getMember(val, userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMemberRequest = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_REQUEST_REQUEST });

  return api.eligibility.getMemberRequest(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_REQUEST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_REQUEST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getTaskOwners = (val: any, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_TASK_OWNERS_REQUEST });

  return api.eligibility.getTaskOwners(val, userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_TASK_OWNERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_TASK_OWNERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProvider = (providerKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_REQUEST });

  return api.eligibility.getProvider(providerKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const requestMember = (request: any, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.REQUEST_MEMBER_REQUEST });

  request.UserId = userId;

  return api.eligibility.requestMember(request)
    .then((res: any) => {

      dispatch({
        type: types.REQUEST_MEMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.REQUEST_MEMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const emailUpdatedMemberInfo = (memberInfo: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibility.isEmailing) { return Promise.reject(); }

  dispatch({ type: types.EMAIL_UPDATED_MEMBER_INFO_REQUEST });

  return api.eligibility.emailUpdatedMemberInfo(memberInfo)
    .then((res: any) => {

      dispatch({
        type: types.EMAIL_UPDATED_MEMBER_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.EMAIL_UPDATED_MEMBER_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

/**
 * This one is used to validate the measures on DOS popup 2 before going to the claims final submission page
 * @param payload - payload just sends in the measures similar to the PortalClaimDetails
 * @returns
 */
export const validateMeasures = (payload: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_CONDITION_CODES_REQUEST });

  return api.eligibility.validateMeasures(payload)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_CONDITION_CODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_CONDITION_CODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMemberConditionCodes = (companyId: string, membKeyId: string, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_CONDITION_CODES_REQUEST });

  const model = {
    CompanyId: companyId,
    MembKeyId: membKeyId,
    UserId:    userId,
  };

  return api.eligibility.getMemberConditionCodes(model)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_CONDITION_CODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_CONDITION_CODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
